export default __webpack_public_path__ + "static/media/home_img.9cf7a063.svg";